// extracted by mini-css-extract-plugin
export default {"appealsList__title":"LkmAppeals_appealsList__title__L2wo+","appealsList":"LkmAppeals_appealsList__mfEaf"};